export default "__VITE_ASSET__B$Hq4SL2__"